<template>
  <div>
    <v-container grid-list-lg>
      <v-layout wrap>
        <v-flex>
          <router-link to="/dashboard">
            <img :height="imgHeight" :src="logo" />
          </router-link>
        </v-flex>
        <v-spacer></v-spacer>
        <v-flex text-xs-right>
          <v-btn class="accent" to="/dashboard">
            <strong>Back</strong>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <h3>PRIVACY STATEMENT</h3>
      <br />
      <ol>
        <li>
          <strong class="accent--text"
            >MERCK, INC. General Terms and Conditions.</strong
          >
        </li>
        <p>
          Access to and use of this website are both subject to the following
          conditions. Should you disagree with these conditions, please do not
          use this website.
        </p>
        <p>
          This website is operated by IPADAMA 360 INC., a service provider of
          Merck, Inc. (hereinafter also “Merck”, “we”, “us” or “our”).
        </p>
        <p>
          This website is for general informational and educational purposes
          only and, although it may be available in different languages, it is
          not country specific. By using this website you declare that you use
          it and its content at your own risk.
        </p>
        <p>
          Under no circumstances may this website or its contents may be used or
          understood as a substitute for healthcare professional advice and is
          not to be used for diagnosis of any health problem or disease.
          Patients should always consult a doctor or another healthcare
          professional for medical advice or information about diagnosis and
          treatment. If your situation is serious, always call the emergency
          service.
        </p>
        <li>
          <strong class="accent--text">1. Exclusion of liability</strong>
        </li>
        <p>
          We have compiled the content of this website carefully and in
          accordance with the current state of knowledge. However, we give no
          warranty, neither expressly nor tacitly, for the completeness or
          correctness of the details provided on this website. Please be aware,
          in particular, that the details we provide may no longer be
          up-to-date.
        </p>
        <p>
          Access to and use of this website and of any associated sites or sites
          connected via links take place at the user’s own risk. We accept no
          liability for loss, damage or compensation claims due to missing or
          incorrect details. The Website and any services available through it
          are available solely for the User's personal and not for commercial
          use.
        </p>
        <li>
          <strong class="accent--text">2. Legal notes</strong>
        </li>
        <p>
          All rights to the website or arising from the same shall remain with
          Merck, Inc. or its affiliates.
        </p>
        <p>
          We may modify this website and/or discontinue its operation at any
          time without prior announcement, either wholly or in parts, at ourits
          own discretion and without accepting liability. Neither is Merck,
          under an obligation to update the content of this website.
        </p>
        <p>
          Unless otherwise indicated, all details, documents and presentations
          published on our website are under the sole ownership of Merck, Inc.,
          its affiliates or third parties that have authorized its use. Unless
          written consent has been obtained from us, no permission is given to
          import published and copyrighted content from our website to other
          programs or website or to use such content in any other way.
        </p>
        <p>
          Access to this website is public and does not require registration.
          Please, be aware that users may be subject to provisions under local
          legislation. International users must observe the special provisions
          under local legislation. Users in the United States are subject to the
          conditions of use for the websites of our U.S. companies.
        </p>
        <li>
          <strong class="accent--text">3. Personal data</strong>
        </li>
        <p>
          We are concerned to ensure the protection of your personal data. You
          will find information on the use of personal data in the Privacy
          Statement.
        </p>
        <li>
          <strong class="accent--text">4. Content</strong>
        </li>
        <p>
          This website may contain general information regarding medical
          conditions. Such information is provided for informational purposes
          only, under no circumstances may it be used or understood as a
          substitute for healthcare professional advice and is not to be used
          for diagnosis of any health problem or disease. Patients should always
          consult a doctor or another healthcare professional for medical advice
          or information about diagnosis and treatment.
        </p>
        <p>
          The website may also include links to third-party websites. Such links
          are provided merely as a convenience. The content of third-party web
          sites is beyond our control and we make no warranties or
          representations regarding the accuracy or validity of such
          information. Neither do the links represent any kind of support or
          endorsement of the linked website's contents. Access to and use of
          sites connected via links take place at the user’s own risk.
        </p>
        <p>As of: April 2024</p>
      </ol>
      <h3>CONTACT US</h3>
      <p><b>You may contact us at medinfoph@merckgroup.com.</b></p>
      <p><b>Date of last update: December 2023.</b></p>
    </v-container>
  </div>
</template>
<script>
export default {
  data() {
    return {
      imgHeight: 128,
      logo: require("@/assets/svg/ELITE Logo.svg"),
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/footer/privacy.vue